import { AfterViewInit, Component, Injector, Input, Output, ElementRef, EventEmitter, OnInit, Renderer, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { GridService } from './grid.service';
import { GridComponent } from './grid.component';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
//import { PlaceHolderService } from '../modal/placeholder.service';
import { DataService } from '../../services/data/data.service';
import { ReportService } from '../../services/report/report.service';
import { PaginationService } from '../../services/pagination/pagination.service';
import { ReactiveformService } from '../../services/reactiveform/reactiveform.service';
import { GenericListModalService } from '../../services/genericlistmodal/genericlistmodal.service';

@Component({
  selector: 'reportgrid',
  template: `
  <grid 
    [name]="name" [title]="title" [href]="href" [parentFieldName]="parentFieldName"
    [autoSearch]="autoSearch" [templateNameRecord]="templateNameRecord" [openMode]=1 [parentId]="parentId" [filter]="filter">
  </grid>`,
  providers: [GenericdatasetService, GridService, PaginationService]
})

export class ReportGridComponent extends GridComponent {

  constructor(
    injector: Injector,
    public renderer: Renderer,
    public gridService: GridService,
    public itemService: GenericdatasetService,
    //public hotkeysService: HotkeysService,
    public dataService: DataService,
    public paginationService: PaginationService,
    public genericlistService: GenericListModalService,
    public reactiveformService: ReactiveformService,
    public reportService: ReportService) {
    super(injector, renderer, gridService, itemService/*, hotkeysService*/, dataService, paginationService, reactiveformService);
    this.actions.push({ glyph: 'fa fa-envelope', function: () => { this.email(); } });
  }

  public onCreate() {
    this.openList('GenericList', 'reportcategories', 'Report Type', 'reportcategories', '', '', 'reportcategories');
  }

  public openList(templateName: string, restName: string, title: string, href: string, filter: string, key: string, templateNameRecord: string): void {
    /*let parameters;
    parameters = {
      modal: true,
      close: (id: any) => {
        this.close(id);
      },
      options: {},
      id: 0
    };
    parameters.options = { restName, title, href, filter, listFilter: key, templateNameRecord };
    this.modalId = this.placeholderService.addModal(templateName, parameters);*/
    this.genericlistService.restName = this.restName;
    this.genericlistService.title = this.title;
    this.genericlistService.href = this.href;
    this.genericlistService.filter = this.filter;
    this.genericlistService.listFilter = key;
    this.genericlistService.infinite = this.infinite;
    this.genericlistService.templateNameRecord = this.templateNameRecord;
    this.genericlistService.close = (id: any) => {
      this.close(id);
    }
    this.genericlistService.displayed = true;
  }

  public openReport(parameters: any, templateNameRecord: string) {
    parameters['modal'] = true;
    parameters['close'] = (id: any) => {
      this.close(id);
    };
    parameters['options'] = {};
    parameters['id'] = 0;
    if (templateNameRecord == 'Generic') {
      parameters.options = { restName: this.restName, glyph: this.glyph, title: this.title, backLink: this.restName };
    }
    parameters['parentId'] = this.parentId;
    this.dataService.setStorage(parameters);
    //this.modalId = this.placeholderService.addModal(templateNameRecord, parameters);
  }

  public openEmail(parameters: any, templateNameRecord: string) {
    parameters['modal'] = true;
    parameters['close'] = (id: any) => {
      this.close(id);
    };
    parameters['options'] = {};
    parameters['id'] = 0;
    if (templateNameRecord == 'Generic') {
      parameters.options = { restName: this.restName, glyph: this.glyph, title: this.title, backLink: this.restName };
    }
    //this.modalId = this.placeholderService.addModal(templateNameRecord, parameters);
  }

  public close(item: any) {
    super.close(item);
    if ((item[0] != null) && (item[0].id >= 1000)) {
      this.reportService.getReportTypesFromCategory(item[0].id).subscribe(
        (res) => {
          const parameters: any = {};
          parameters['initValue'] = [{ parentFieldName: 'reporttype_id', parentId: res[0].id }];
          parameters['initValue'].push({ parentFieldName: 'name', parentId: res[0].name });
          this.openReport(parameters, 'Report');
        }, (error) => {
          console.log(error);
        }
      );
    }
  }
  public email() {
    const selectedItems = this.items
      .filter((item) => item.selected == true);
    const parameters: any = {};
    let attachments = '';
    selectedItems.forEach((item) => {
      attachments = attachments + item.report_id + '.pdf;';
    });
    parameters['initValue'] = [{ parentFieldName: 'recipient', parentId: 'pyf@lyseo.com' }];
    parameters['initValue'].push({ parentFieldName: 'attachments', parentId: attachments });
    parameters['initValue'].push({ parentFieldName: 'subject', parentId: 'Your document(s)' });
    parameters['initValue'].push({ parentFieldName: 'text', parentId: 'Please find attached your document(s)' });
    this.openEmail(parameters, 'Email');
    this.selectAll = false;
  }
  public uploadFile(): void {
    super.uploadFile();
    this.openList('GenericList', 'reportcategories', 'Report Type', 'reportcategories', '', '', 'reportcategories');
  }
}
